import { Component, OnInit, Input, OnChanges, SimpleChanges, ElementRef, Output, EventEmitter, AfterViewInit, HostListener} from '@angular/core';
import {Warehouse, Warehouse4} from '../../project/warehouse';
import {Frame4Component} from '../frames/frame4.component';
import * as d3 from 'd3';


@Component({
  selector: 'app-detail-uf4',
  templateUrl: './detail-uf.component.html'
})
export class DetailUf4Component extends Frame4Component implements OnInit,  OnChanges, AfterViewInit {

  @Input() displacementModal: boolean;

  margin = {top: 3*this.radio, right: 3*this.radio, bottom: 3*this.radio, left: 3*this.radio};
  fontsize = "14px";

  constructor(el: ElementRef) {
    super(el);
    this.div = "#detail-uf";
    this.radio = 5;
  }

  ngOnInit(){
    this.width = 500 - this.margin.left - this.margin.right;
    this.height = 200 - this.margin.top - this.margin.bottom;
    this.initFrame();
  }

  ngOnChanges(changes: SimpleChanges){
    if(changes.displacementModal && changes.displacementModal.currentValue){
      setTimeout(() => {
        this.ngOnInit();
        this.reDraw();
      }, 300);
    }
  }

  ngAfterViewInit(){
  }

  initFrame(){
    this.prepareData();
    this.createFrame();
    this.drawNumbers();
  }

  drawNumbers(){
    let c1 = this.svg.append("circle")
      .style("fill", "white")
      .style("stroke", "#77768d")
      .style("stroke-width", "2px")
      .attr("cx", this.origin[0]-3*this.radio-2)
      .attr("cy", this.origin[1]+3*this.radio+2)
      .attr("r", this.radio*3);
    let t1 = this.svg.append("text")
      .text(1)
      .attr("font-size", this.fontsize)
      .attr("fill", "#77768d")
      .attr("text-anchor", "middle")
      .attr("dominant-baseline", "central")
      .attr("transform", "translate("+(this.origin[0]-3*this.radio-2)+","+(this.origin[1]+3*this.radio+2)+")");

    let c2 = this.svg.append("circle")
      .style("fill", "white")
      .style("stroke", "#77768d")
      .style("stroke-width", "2px")
      .attr("cx", this.origin[0]-3*this.radio-2)
      .attr("cy", this.origin[1]-this.data.height_l-3*this.radio-2)
      .attr("r", this.radio*3);
    let t2 = this.svg.append("text")
      .text(2)
      .attr("font-size", this.fontsize)
      .attr("fill", "#77768d")
      .attr("text-anchor", "middle")
      .attr("dominant-baseline", "central")
      .attr("transform", "translate("+(this.origin[0]-3*this.radio-2)+","+(this.origin[1]-this.data.height_l-3*this.radio-2)+")");

    let c3 = this.svg.append("circle")
      .style("fill", "white")
      .style("stroke", "#77768d")
      .style("stroke-width", "2px")
      .attr("cx", this.origin[0]+this.data.width_l/2)
      .attr("cy", this.origin[1]-this.data.height_l+this.data.width_l/2*this.data.slope_l-4*this.radio-2)
      .attr("r", this.radio*3);
    let t3 = this.svg.append("text")
      .text(3)
      .attr("font-size", this.fontsize)
      .attr("fill", "#77768d")
      .attr("text-anchor", "middle")
      .attr("dominant-baseline", "central")
      .attr("transform", "translate("+(this.origin[0]+this.data.width_l/2)+","+(this.origin[1]-this.data.height_l+this.data.width_l/2*this.data.slope_l-4*this.radio-2)+")");

    let c4 = this.svg.append("circle")
      .style("fill", "white")
      .style("stroke", "#77768d")
      .style("stroke-width", "2px")
      .attr("cx", this.origin[0]+this.data.width_l+3*this.radio+2)
      .attr("cy", this.origin[1]-this.data.height_l+this.data.width_l*this.data.slope_l-3*this.radio-2)
      .attr("r", this.radio*3);
    let t4 = this.svg.append("text")
      .text(4)
      .attr("font-size", this.fontsize)
      .attr("fill", "#77768d")
      .attr("text-anchor", "middle")
      .attr("dominant-baseline", "central")
      .attr("transform", "translate("+(this.origin[0]+this.data.width_l+3*this.radio+2)+","+(this.origin[1]-this.data.height_l+this.data.width_l*this.data.slope_l-3*this.radio-2)+")");

    let c5 = this.svg.append("circle")
      .style("fill", "white")
      .style("stroke", "#77768d")
      .style("stroke-width", "2px")
      .attr("cx", this.origin[0]+3*this.radio+2+this.data.width_l)
      .attr("cy", this.origin[1]+3*this.radio+2)
      .attr("r", this.radio*3);
    let t5 = this.svg.append("text")
      .text(5)
      .attr("font-size", this.fontsize)
      .attr("fill", "#77768d")
      .attr("text-anchor", "middle")
      .attr("dominant-baseline", "central")
      .attr("transform", "translate("+(this.origin[0]+3*this.radio+2+this.data.width_l)+","+(this.origin[1]+3*this.radio+2)+")");
  }
}



// WEBPACK FOOTER //
// ./src/app/sketch/detail-uf/detail-uf4.component.ts